import App from './App';
import { renderNav } from './core/strategies';
new App().start(renderNav);